import mapKeys from 'lodash/mapKeys';
import snakeCase from 'lodash/snakeCase';

// All of the API endpoints about an order that comes from Eagle
// transforms the customisation keys from snake case, which is what Chameleon/Muse
// store them as, to camel case. Due to this mismatch of strings Website,
// Squid v2 and Chameleon/Muse got different keys and caused a lot of issues to
// customers as well as developers when following the code. So because Eagle is
// is the one that transforms them what we do is transform back to the correct case
// them whenever we call any of those endpoints that transform customisation on return.

// TODO: Remove this when we stop transforming customisations in Eagle

const transformCustomisations = (order) => {
  return {
    ...order,
    items: order.items.map(item => {
      return {
        ...item,
        customisations: mapKeys(item.customisations, (value, key) => snakeCase(key)),
      };
    }),
  };
};

export default transformCustomisations;



// WEBPACK FOOTER //
// ./src/client/js/facades/eagle/helpers/transform-customisations.js